// extracted by mini-css-extract-plugin
export var column = "_ug-0";
export var divider = "_ug-2";
export var timePicker = "_ug-1";